// Format cents to a money string using Shopify if available, else a basic fallback
function formatMoneyFromCents(cents) {
    try {
      const hasFormatter = typeof window.Shopify?.formatMoney === 'function';
      const formatTemplate =
        (window.theme && window.theme.moneyFormat) ||
        window.Shopify?.money_format ||
        '${{amount}}';
      if (hasFormatter) {
        return window.Shopify.formatMoney(Math.round(cents), formatTemplate);
      }
    } catch (e) {
      // no-op
    }
    const amount = (Math.round(cents) / 100).toFixed(2);
    const symbol = window.Shopify?.currency?.symbol || '';
    return symbol ? `${amount} ` : amount;
  }
  
  // Convert all currency spans within a container using window.Shopify.currency.rate
  function convertCurrencyInContainer(container) {
    const rateRaw = window.Shopify?.currency?.rate;
    const rate = Number(rateRaw);
    const effectiveRate = Number.isFinite(rate) && rate > 0 ? rate : 1;
    if (!container) return;
    const nodes = container.querySelectorAll('.js-currency[data-currency-cents]');
    nodes.forEach((node) => {
      const baseCents = Number(node.getAttribute('data-currency-cents'));
      if (!Number.isFinite(baseCents)) return;
      const convertedCents = Math.round(baseCents * effectiveRate);
      node.textContent = formatMoneyFromCents(convertedCents);
    });
  }
  
  // Extract section inner HTML using the theme's convention
  function getSectionInnerHTML(html, selector) {
    try {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const node = parsed.querySelector(selector || '.shopify-section');
      return node ? node.innerHTML : html;
    } catch (e) {
      return html;
    }
  }

  // Determine which sections to request and how to replace them
  function getLoyaltySectionsToRender() {
    const sections = [];

    // Main cart footer on cart page
    const mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter && mainCartFooter.dataset && mainCartFooter.dataset.id) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.js-contents',
      });
    }

    // Cart drawer section
    const ajaxCartContainer = document.getElementById('shopify-section-ajax-cart');
    if (ajaxCartContainer) {
      sections.push({
        id: 'shopify-section-ajax-cart',
        section: 'ajax-cart',
        selector: '.shopify-section',
      });
    }

    // Cart icon bubbles (desktop and mobile) both come from cart-icon-bubble section
    if (document.getElementById('cart-icon-bubble')) {
      sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }
    if (document.getElementById('mobile-cart-icon-bubble')) {
      sections.push({ id: 'mobile-cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }

    return sections;
  }

  function init(selector = '.select-point-redemption-method') {
    const dropdowns = document.querySelectorAll(selector);
  
    for (const dropdown of dropdowns) {
      const dropdownTrigger = dropdown.querySelector(
        '.select-point-redemption-method__trigger',
      );
      const dropdownContent = dropdown.querySelector(
        '.select-point-redemption-method__dropdown',
      );
      const dropdownOptions = dropdown.querySelectorAll(
        '.select-point-redemption-method__option',
      );
      const message = dropdown.querySelector(
        '.select-point-redemption-method_message',
      );
  
      // Convert currency on initial load of this dropdown
      convertCurrencyInContainer(dropdown);
  
      // Check if event listener already exists
      if (!dropdownTrigger.hasAttribute('data-listener-added')) {
        dropdownTrigger.addEventListener('click', function (e) {
          // If a reward is applied (container has 'selected'), clicking removes it instead of toggling the dropdown
          if (dropdown.classList.contains('selected')) {
            e.preventDefault();
            // Optimistic UI reset
            dropdown.classList.remove('selected');
            const p = dropdownTrigger.querySelector('p');
            if (p) {
              p.textContent = 'NONE';
              p.classList.remove('selected');
            }
            dropdownTrigger.classList.remove('active');
            dropdownContent.classList.remove('active');
            dropdownOptions.forEach((o) => {
              o.classList.remove('selected');
              if (o.dataset.value === '') o.classList.add('selected');
            });
  
            // API call to clear cart attribute with loader
            try {
              const sectionsInfo = getLoyaltySectionsToRender();
              fetch(`${window.Shopify.routes.root}cart/update.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  attributes: { _roadmap_loyalty_reward_id: '' },
                  sections: sectionsInfo.map(s => s.section),
                  sections_url: window.location.pathname,
                }),
                mode: 'cors',
                credentials: 'include',
              })
                .then(response => response.json())
                .then(data => {
                  if (data.sections) {
                    sectionsInfo.forEach((section) => {
                      const html = data.sections[section.section];
                      if (!html) return;
                      const container =
                        document.getElementById(section.id) ||
                        document.getElementById(`shopify-section-${section.section}`);
                      if (!container) return;
                      const elementToReplace =
                        container.querySelector(section.selector) || container;
                      elementToReplace.innerHTML = getSectionInnerHTML(html, section.selector);
                    });
                    // Reinitialize dropdown listeners
                    window.initSelectPointRedemptionMethod();
                  } else {
                    // Fallback to full cart reload if section not available
                    if (window.ajaxCart && window.ajaxCart.load) {
                      window.ajaxCart.load();
                    } else {
                      window.location.reload();
                    }
                  }
                })
                .catch(console.error);
            } catch (err) {
              console.error(err);
            }
            return; // Do not proceed to open dropdown
          }
          // Normal behaviour: toggle dropdown visibility
          dropdownTrigger.classList.toggle('active');
          dropdownContent.classList.toggle('active');
        });
        dropdownTrigger.setAttribute('data-listener-added', 'true');
      }
  
      dropdownOptions.forEach((option) => {
        // Check if event listener already exists
        if (!option.hasAttribute('data-listener-added')) {
          option.addEventListener('click', function () {
            // Check if option is disabled
            if (option.dataset.disabled === '1') {
              // Just close the dropdown if disabled
              dropdownTrigger.classList.remove('active');
              dropdownContent.classList.remove('active');
              return;
            }
  
            const selectedValue = option.dataset.value;
            const triggerP = dropdownTrigger.querySelector('p');
            const richHtml = option.innerHTML && option.innerHTML.trim().length > 0
              ? option.innerHTML
              : option.dataset.text;
            triggerP.innerHTML = richHtml;
            triggerP.classList.add('selected');
            dropdownOptions.forEach((option) => {
              option.classList.remove('selected');
            });
            option.classList.add('selected');
            dropdownTrigger.classList.remove('active');
            dropdownContent.classList.remove('active');
  
            // Ensure any currency spans in the trigger are converted
            convertCurrencyInContainer(dropdown);
  
            
            const sectionsInfo = getLoyaltySectionsToRender();
            fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                attributes: {
                  _roadmap_loyalty_reward_id: selectedValue,
                },
                sections: sectionsInfo.map(s => s.section),
                sections_url: window.location.pathname,
              }),
              mode: 'cors',
              credentials: 'include',
            })
              .then(response => response.json())
              .then(data => {
                if (data.sections) {
                  sectionsInfo.forEach((section) => {
                    const html = data.sections[section.section];
                    if (!html) return;
                    const container =
                      document.getElementById(section.id) ||
                      document.getElementById(`shopify-section-${section.section}`);
                    if (!container) return;
                    const elementToReplace =
                      container.querySelector(section.selector) || container;
                    elementToReplace.innerHTML = getSectionInnerHTML(html, section.selector);
                  });
                  // Reinitialize dropdown listeners
                  window.initSelectPointRedemptionMethod();
                } else {
                  // Fallback to full cart reload if section not available
                  if (window.ajaxCart && window.ajaxCart.load) {
                    window.ajaxCart.load();
                  } else {
                    window.location.reload();
                  }
                }
              })
              .catch(console.error);
          });
          option.setAttribute('data-listener-added', 'true');
        }
      });
    }
  }
  window.initSelectPointRedemptionMethod = init;

document.addEventListener('DOMContentLoaded', function () {
  init();
});